import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Schema, SelectComponentData } from '../../package.models';
import { AppState } from '../../../store';
import { setComponentValidity, updateRawComponent } from '../../store/component.actions';

@Component({
  selector: 'select-editor',
  template: `
    <div class="select-editor">
      <div class="row">
        <div class="col-md-12">
          <label
            ><b>{{ 'select_component.fields_mapping' | translate }}</b></label
          >
          <select-collection
            [records]="rawComponent.fields || []"
            (recordsChange)="onRecordsChange($event)"
            [parentSchemas]="parentSchemas"
            (validityChange)="onValidityChange($event)"
          ></select-collection>
        </div>
      </div>
      <div class="row">
        <component-previewer [componentId]="rawComponent.id"></component-previewer>
      </div>
    </div>
  `,
})
export class SelectEditorComponent {
  @Input() rawComponent: SelectComponentData;
  @Input() parentSchemas: Schema[];

  constructor(private store: Store<AppState>) {}

  onRecordsChange(records) {
    this.store.dispatch(updateRawComponent({ rawComponent: { fields: records } }));
  }

  onValidityChange(isValid: boolean) {
    this.store.dispatch(setComponentValidity({ isComponentFormValid: isValid }));
  }
}
